export default __webpack_public_path__ + "static/media/novoLogoOnfarmRumina.d6feae11.png";